/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Amateur_2_HeadingInputs */

const en_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Follow-Through Phase: The Primary Mechanism of Dissipation`)
};

const es_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fase de follow-through: el mecanismo principal de disipación`)
};

const de_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Follow-Through-Phase: Der primäre Mechanismus der Dissipation`)
};

const zh_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送杆阶段：力量消散的主要机制`)
};

const ar_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحلة المتابعة بعد الضربة: الآلية الأساسية للتبديد`)
};

const fr_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La phase de suivi : le mécanisme principal de dissipation`)
};

const vi_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giai đoạn follow-through: cơ chế tiêu tán chính`)
};

const sw_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awamu ya mwendelezo wa pigo: utaratibu mkuu wa utawanyaji`)
};

const th_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วงฟอลโลว์ทรู: กลไกหลักของการกระจายแรง`)
};

const bs_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faza follow-througha: primarni mehanizam disipacije`)
};

const ja_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォロー徹底したフェーズ: 散逸の第一次メカニズム`)
};

const ko_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진행 단계 : 분쟁의 1 차 메커니즘`)
};

const pt_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Fase Seguida: O Mecanismo Primário de Dissipação`)
};

const it_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fase successiva: Il meccanismo primario della dissipazione`)
};

const sv_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Följande fas: Den primära mekanismen för missförstånd`)
};

const nl_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De volgende fase: het primaire mechanisme van dissipatie`)
};

const da_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemsvinget: den vigtigste mekanisme til kraftfordeling`)
};

const nb_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Følge-gjennom fase: Den primære mekanismen for dissipasjon`)
};

const fi_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava vaihe: Ensisijainen hävikkimekanismi`)
};

const pl_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faza Follow- Through: Podstawowy mechanizm rozproszenia`)
};

const ru_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующая фаза: основной механизм рассеяния`)
};

const tr_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takip Evresi: Kuvvet Dağıtımının Temel Mekanizması`)
};

const hi_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवर्ती चरण: विघटन की प्राथमिक तंत्र`)
};

const id_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fase Follow-Through: Mekanisme Utama Penyebaran Gaya`)
};

const ms_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasa Ikut-Lajak: Mekanisme Utama Penyebaran Daya`)
};

const cs_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze sledování: Primární mechanismus rozptylu`)
};

const el_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Φάση: Ο Πρωτογενής Μηχανισμός Διάδοσης`)
};

const he_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלב המעקב: המנגנון העיקרי לפיזור כוח`)
};

const af_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die deurvolgfase: die primêre meganisme van kragverspreiding`)
};

const hu_method_content_step_06_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A kilendítési fázis: az erőelvezetés elsődleges mechanizmusa`)
};

/**
* | output |
* | --- |
* | "The Follow-Through Phase: The Primary Mechanism of Dissipation" |
*
* @param {Method_Content_Step_06_Detail_Amateur_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_amateur_2_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Amateur_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Amateur_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_amateur_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_amateur_2_heading(inputs)
	return en_method_content_step_06_detail_amateur_2_heading(inputs)
});